import { EVisa2PayCardType } from '../enums/billing/EVisa2PayCardType';

import { normalizeCardNumberDigits } from './detectVisa2PayCardType';

export type TCardDepositCardInput = {
  cardType: EVisa2PayCardType;
  cardNumber: string;
  cardCVV: string;
  cardExpYear: string;
  cardExpMonth: string;
};

export function normalizeCardDepositExpiryMonth(value: string): string {
  const trimmed = value.trim();
  if (!/^\d{1,2}$/.test(trimmed)) {
    return trimmed;
  }

  const month = Number(trimmed);
  if (!Number.isInteger(month) || month < 1 || month > 12) {
    return trimmed;
  }

  return String(month).padStart(2, '0');
}

export function normalizeCardDepositExpiryYear(value: string): string {
  const trimmed = value.trim();
  if (/^\d{2}$/.test(trimmed)) {
    return `20${trimmed}`;
  }

  return trimmed;
}

/** Display helper: API/draft may store YYYY, form UI uses YY. */
export function toCardDepositExpiryYearUi(value: string): string {
  const trimmed = value.trim();
  if (/^\d{4}$/.test(trimmed)) {
    return trimmed.slice(-2);
  }

  return trimmed.replace(/\D/g, '').slice(0, 2);
}

export function isValidCardDepositExpiryMonth(value: string): boolean {
  return /^(0[1-9]|1[0-2])$/.test(normalizeCardDepositExpiryMonth(value));
}

export function isValidCardDepositExpiryYearUi(value: string): boolean {
  return /^\d{2}$/.test(value.trim());
}

export function normalizeCardDepositCardDetails(
  card: TCardDepositCardInput,
): TCardDepositCardInput {
  return {
    ...card,
    cardNumber: normalizeCardNumberDigits(card.cardNumber),
    cardCVV: card.cardCVV.trim(),
    cardExpMonth: normalizeCardDepositExpiryMonth(card.cardExpMonth),
    cardExpYear: normalizeCardDepositExpiryYear(card.cardExpYear),
  };
}

/** Visa2Pay cardName built from billing first/last name. */
export function buildCardDepositCardName(
  firstName: string,
  lastName: string,
): string {
  return `${firstName.trim()} ${lastName.trim()}`.trim();
}
